import React from 'react'
import {CaseFilesSelector} from 'screens/Orders/Steps/CaseFilesSelector'
import {PrescriptionSelector} from 'screens/Orders/Steps/PrescriptionSelector'
import ReviewAndSendStep from 'screens/Orders/Steps/ReviewAndSendStep'
import OrderDetailsStep from './OrderDetailsStep'
import {StepperProvider} from 'contexts/StepperContext'

const StepWrapper: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <StepperProvider>{children}</StepperProvider>
}

export const getCreateOrderSteps = () => {
  return [
    {
      title: 'Order details',
      id: 0,
      content: (
        <StepWrapper>
          <OrderDetailsStep />
        </StepWrapper>
      ),
    },
    {
      title: 'Files',
      id: 1,
      content: (
        <StepWrapper>
          <CaseFilesSelector />
        </StepWrapper>
      ),
    },
    {
      title: 'Prescription',
      id: 2,
      content: (
        <StepWrapper>
          <PrescriptionSelector />
        </StepWrapper>
      ),
    },
    {
      title: 'Review and send',
      id: 3,
      content: (
        <StepWrapper>
          <ReviewAndSendStep />
        </StepWrapper>
      ),
    },
  ]
}
